import * as documents from "./documents";
import * as documentsDownload from "./documentsDownload";

export const datasheet = { documents, documentsDownload };
